import { graphql, useStaticQuery } from "gatsby";

export type Props = {
  allPortalLatestArticles: {
    nodes: {
      url: string;
      title: string;
      id: string;
      preamble: string;
      publishedAt: string;
      coverImageUrl: string;
    }[];
  };
};

export const useLatestArticlesData = () => {
  const { allPortalLatestArticles }: Props = useStaticQuery(
    graphql`
      {
        allPortalLatestArticles(filter: { id: { ne: "dummy" } }) {
          nodes {
            url
            title
            preamble
            id
            publishedAt
            coverImageUrl
          }
        }
      }
    `
  );
  return allPortalLatestArticles.nodes;
};
